var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"object-store-badges"},_vm._l((_vm.badges),function(badge,idx){return _c(_setup.ObjectStoreBadge,{key:idx,attrs:{"badge":badge,"size":_vm.size,"more-on-hover":_vm.moreOnHover}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }